const RequestRegionSection = () => {
  return <div data-sentry-component="RequestRegionSection" data-sentry-source-file="RequestRegionSection.tsx">
      <p className='text-lg font-semibold'>
        {`We don't have any properties available matching your search, but we're
          adding new ones every day!`}
      </p>
      <p className='mt-5 text-grayText'>
        You can try adjusting your dates or exploring nearby areas on the map.
      </p>

      <div className='fixed bottom-[84px] left-0 z-[-1] flex w-full items-center justify-center px-5 md:hidden'>
        <div className='full rounded-xl border-l-4 border-l-secondary1000 bg-white px-5 py-2.5 shadow-[0_0_12px_rgba(34,34,34,.2)]'>
          <p className='text-sm font-semibold leading-6 '>
            No results found in this area
          </p>
          <p className='text-sm leading-6 '>Try broadening your search</p>
        </div>
      </div>
    </div>;
};
export default RequestRegionSection;